import { render, staticRenderFns } from "./Descriptions.vue?vue&type=template&id=2a8c1a0e&scoped=true"
import script from "./Descriptions.vue?vue&type=script&setup=true&lang=js"
export * from "./Descriptions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Descriptions.vue?vue&type=style&index=0&id=2a8c1a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c1a0e",
  null
  
)

export default component.exports